import {
  TextField,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Stack,
} from "@mui/material"
import { DropzoneArea } from "mui-file-dropzone"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DateTimePicker } from "../ui/DateTimePickers"
import FormItem from "../ui/FormItem"
import Modal from "../ui/Modal"

const AddTestModal = (props) => {
  return (
    <Modal {...props} title="Add Test" actionText="Add">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <FormItem label="Test name">
          <TextField />
        </FormItem>
        <FormItem label="Select batches">
          <FormGroup row>
            <FormControlLabel control={<Checkbox />} label="Batch 1" />
            <FormControlLabel control={<Checkbox />} label="Batch 2" />
          </FormGroup>
        </FormItem>
        <FormItem label="Total marks">
          <TextField type="number" />
        </FormItem>
        <Stack direction="row" spacing={3} alignItems="center">
          <FormItem label="Test start time">
            <DateTimePicker />
          </FormItem>
          <FormItem label="Test end time">
            <DateTimePicker />
          </FormItem>
        </Stack>
        <FormItem label="Test file">
          <DropzoneArea
            acceptedFiles={["application/pdf"]}
            useChipsForPreview
          />
        </FormItem>
      </LocalizationProvider>
    </Modal>
  )
}

export default AddTestModal
